import React from 'react';
import { string, number } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Resource as ResourceComponent } from '@thd-olt-component-react/resource';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

export function Resource({
  id,
  layoutRendererPrerenderedChildIndex
}) {
  const componentPosition = layoutRendererPrerenderedChildIndex ? layoutRendererPrerenderedChildIndex + 1 : 1;

  return (
    <ErrorBoundary name="resource">
      <QueryProvider key={id} cacheKey="resource-cache">
        <ResourceComponent
          componentId={id}
          componentClass="Resource"
          componentPosition={componentPosition}
        />
      </QueryProvider>
    </ErrorBoundary>
  );
}

Resource.propTypes = {
  id: string,
  layoutRendererPrerenderedChildIndex: number,
};

Resource.defaultProps = {
  id: undefined,
  layoutRendererPrerenderedChildIndex: undefined,
};
